import { render, staticRenderFns } from "./EDI.vue?vue&type=template&id=a8064066&scoped=true&"
var script = {}
import style0 from "./EDI.vue?vue&type=style&index=0&id=a8064066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8064066",
  null
  
)

export default component.exports